module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/catering-tile-49d417026362165990c1d9f9f65a9d5a.jpg";